export const REPORT_FILTERS = {
    countries: ["All Countries", "Fiji", "Guyana", "Mauritius", "Trinidad & Tobago", "South Africa", "Suriname", "Global"],
    types: ["All Types", "Government Report", "NGO & Civil Society", "Academic Research", "Census Data", "Labour Commission", "UN Report"],
    access: ["All Access", "Open Access", "Restricted"]
};

export const REPORTS_DB = [
    {
        id: "RPT-1920-FJI",
        slug: "fiji-labour-commission-report-1920",
        title: "Report of the Commission of Enquiry into the Cost of Living of Indian Labourers in Fiji",
        author: "Fiji Legislative Council",
        organization: "Government of Fiji",
        year: 1920,
        country: "Fiji",
        type: "Labour Commission",
        access: "Open Access",
        abstract: "This foundational government report details the severe economic conditions, soaring cost of living, and widespread malnutrition faced by indentured and newly freed Indian laborers in Fiji following World War I. It was commissioned in direct response to the massive 1920 strikes led by Manilal Doctor.",
        pdfLink: "/mock-pdfs/fiji-labour-1920.pdf",
        tags: ["Cost of Living", "Strikes", "Manilal Doctor", "Economics"]
    },
    {
        id: "RPT-1871-BGU",
        slug: "des-voeux-commission-british-guiana-1871",
        title: "Report of the Commissioners Appointed to Enquire into the Treatment of Immigrants in British Guiana",
        author: "William Des Voeux & Commission",
        organization: "British Colonial Office",
        year: 1871,
        country: "Guyana",
        type: "Government Report",
        access: "Open Access",
        abstract: "Triggered by a detailed letter from Magistrate George William Des Voeux, this report investigated widespread abuses, fraudulent contracts, and severe mortality rates on sugar estates in British Guiana. While conservative in its final rulings, the testimonies collected form a crucial primary source of immigrant hardship.",
        pdfLink: "/mock-pdfs/des-voeux-1871.pdf",
        tags: ["Abuse", "Mortality", "Legal Enquiry", "Plantation Life"]
    },
    {
        id: "RPT-2022-GLB",
        slug: "un-diaspora-demographic-shift-2022",
        title: "Demographic Shifts in the Global Indian Diaspora: The Girmitiya Legacy",
        author: "Dr. Ananya Sharma",
        organization: "UN Department of Economic and Social Affairs",
        year: 2022,
        country: "Global",
        type: "UN Report",
        access: "Open Access",
        abstract: "A contemporary demographic analysis mapping the socioeconomic progression of the Girmitiya diaspora from the 19th century to the modern era. The report highlights disparities in political representation, linguistic preservation, and modern migration patterns away from the original host countries.",
        pdfLink: "/mock-pdfs/un-demographics-2022.pdf",
        tags: ["Demographics", "Modern Era", "Migration", "Socioeconomic"]
    },
    {
        id: "RPT-1915-SAF",
        slug: "natal-indian-enquiry-commission-1914",
        title: "Report of the Indian Enquiry Commission (Solomon Commission)",
        author: "Sir William Solomon",
        organization: "Union of South Africa",
        year: 1914,
        country: "South Africa",
        type: "Government Report",
        access: "Open Access",
        abstract: "Following the historic 1913 strikes led by Mahatma Gandhi in South Africa, this commission investigated the grievances of Indian workers, specifically focusing on the infamous £3 tax, the non-recognition of Indian marriages, and restrictions on movement across provincial borders.",
        pdfLink: "/mock-pdfs/solomon-commission-1914.pdf",
        tags: ["Gandhi", "1913 Strike", "£3 Tax", "Human Rights"]
    },
    {
        id: "RPT-2019-TTO",
        slug: "trinidad-cultural-retention-ngo-2019",
        title: "Cultural Retention & Linguistic Erosion in Rural Trinidad",
        author: "Caribbean Heritage Trust",
        organization: "Caribbean Heritage NGO",
        year: 2019,
        country: "Trinidad & Tobago",
        type: "NGO & Civil Society",
        access: "Restricted",
        abstract: "An in-depth field study assessing the gradual loss of Bhojpuri dialects and traditional religious practices among fourth and fifth-generation Indo-Trinidadians. The report proposes community-driven educational interventions to preserve intangible cultural heritage.",
        pdfLink: null, // Restricted
        tags: ["Linguistics", "Bhojpuri", "Culture", "Assimilation"]
    }
];

export const getReportBySlug = (slug) => {
    return REPORTS_DB.find(report => report.slug === slug) || null;
};

export const getRelatedReports = (currentSlug, country, type) => {
    return REPORTS_DB.filter(report => 
        report.slug !== currentSlug && 
        (report.country === country || report.type === type)
    ).slice(0, 3);
};
